import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Group,
  Text,
  Textarea,
  Button,
  Paper,
  ActionIcon,
  TextInput,
  Center,
  Title,
  Indicator,
  Input,
  Loader,
  Image,
} from "@mantine/core";
import arrowIcon from "../../assets/img/sendButton.svg";
import clipSvg from "../../assets/img/clipSvg.svg";
import aiStartsSvg from "../../assets/img/mdi_stars.svg";

import { IconMessageChatbot } from "@tabler/icons-react";
import { sendMessage, startChat } from "./Service";
import { useMedplum } from "@medplum/react";
import { showNotification } from "@mantine/notifications";
import { getEducationChat } from "./educationService";
import { Summary } from "../AIRecipes/SummaryAi";
interface Details {
  patientName?: any;
  message?: any;
  sender?: any;
}
interface chat {
  patientName?: any;
  dob?: any;
  mobile?: any;
  qtrId?: any;
  linkedIds?: any;
  patientId?: any;
  qtrResponseIdForChat?: any;
  questionText?: any;
  launchType?: string;
  embed?: boolean;
  chatContext?: string;

}

const ChatMessage: React.FC<Details> = ({ message, sender, patientName }) => {
  return (
    <Group
      position={sender ? "right" : "left"}
      style={{ marginBottom: 10, maxWidth: "100%" }}
      noWrap
    >
      {!sender && (
        <Avatar radius="xl" color="blue">
          {/* {patientName
            .split(" ")
            .map((word: any) => word.slice(0, 1))
            .join("")} */}
          <IconMessageChatbot />
        </Avatar>
      )}

      <Paper
        shadow="sm"
        p="xs"
        radius="md"
        style={{ backgroundColor: sender ? "#e0f7fa" : "#ffffff" }}
      >
        <Text
          size="sm"
          maw={"800px"}
          sx={{ display: "flex", flexWrap: "wrap", wordBreak: "break-word" }}
        >
          {!message.ai ? (
            <Summary title="" text={message.content} old={message?.old??false} />
          ) : (
            message.content
          )}
        </Text>

        <Text size="xs" color="dimmed" align={sender ? "right" : "left"}>
          {message.time.substring(0, 5)}
          {!message.ai && (
            <Button
              sx={{
                position: "relative",
                alignItems: "center",
                right: "22px",
                scale: "0.6",
                top: "8px",
              }}
              size="xs"
              variant="outline"
              ml={10}
            >
              <img src={aiStartsSvg} style={{ marginRight: "2px" }} />
              AI GENERATED
            </Button>
          )}
        </Text>
      </Paper>

      {sender && (
        <Avatar radius="xl" color="#e0f7fa">
          {""
            .split(" ")
            .map((word: any) => word.slice(0, 1))
            .join("")}
        </Avatar>
      )}
    </Group>
  );
};

const ChatUI: React.FC<chat> = ({
  patientName,
  dob,
  mobile,
  qtrId,
  linkedIds,
  patientId,
  qtrResponseIdForChat,
  questionText,
  launchType,
  embed,
  chatContext
}) => {
  const [messages, setMessages] = useState([
    {
      id: 0,
      content: chatContext === "medical-assistant"
        ? "Welcome to Qconnect Patient Comapnion. How may I help you?"
        : qtrResponseIdForChat
          ? "Welcome to Qconnect Education AI. How may I help you?"
          : "Welcome to QConnect Chat Bot",
      time: new Date().toLocaleTimeString(),
      sender: false,
      ai: true,
    },
  ]);

  const [newMessage, setNewMessage] = useState("");
  const [currentLinkId, setCurrentLinkId] = useState();
  const [qtresponseID, setQtresponseID] = useState("");
  const [loader, setloader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setdisabled] = useState(false);


  const messagesContainerRef = useRef<HTMLDivElement>(null);

  const medplum = useMedplum();
  const prevLinkedIds = useRef(linkedIds); // Store previous linkedIds

  useEffect(() => {
    if (qtrResponseIdForChat && messages.length === 1) {
      getRecentMessages();
    }
  }, []);


  useEffect(() => {
    if (qtrId) {
      //  setLoader(true);

      // Check if linkedIds are new
      // const areNewLinkedIds =
      //   JSON.stringify(linkedIds) !== JSON.stringify(prevLinkedIds.current);

      if (launchType === "qnr") {
        handleStartChat();
      }

      // Update the ref with the current linkedIds
      prevLinkedIds.current = linkedIds;
    }
  }, [linkedIds]);

  useEffect(() => {
    const scrollToBottom = () => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTo({
          top: messagesContainerRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    };
    scrollToBottom();
  }, [messages]);

  const getRecentMessages = async () => {
    const comms = await medplum.searchResources('Communication', `_count=100&_offset=0&_sort=_lastUpdated&_total=accurate&based-on=QuestionnaireResponse/${qtrResponseIdForChat}`);
    if (!comms.length) return;
    const formattedMessages = comms
      .filter(({ payload: [{ contentString }] }: any) => contentString && !contentString.startsWith("{") && !contentString.startsWith("Welcome"))
      .map((comm: any, index: number) => {
        return {
          id: index + messages?.length,
          content: comm?.payload[0]?.contentString,
          time: new Date(comm?.meta?.lastUpdated).toLocaleTimeString(),
          sender: comm?.sender?.reference?.includes("Patient"), 
          ai: comm?.sender?.reference?.includes("Patient"),
          old: true
        }
      })
    setMessages((prevMessages) => [...prevMessages, ...formattedMessages]);
  }
  const handleSendMessage = async () => {
    setLoading(true);

    if (
      newMessage.trim() !== "" &&
      qtresponseID &&
      newMessage &&
      currentLinkId
    ) {
      const newMsg = {
        id: messages.length + 1,
        content: newMessage,
        time: new Date().toLocaleTimeString(),
        sender: true,
        ai: true,
      };
      setMessages((prevMessages) => [...prevMessages, newMsg]); // Append both messages
      setNewMessage("");

      const sendMessageResponse = await sendMessage(
        medplum,
        qtresponseID,
        newMessage,
        currentLinkId
      );
      if (!sendMessageResponse) {
        setLoading(false);
        showNotification({
          color: "red",
          message: "Failed",
          autoClose: true,
        });
        return;
      }
      const status = sendMessageResponse?.questionnaireResponse?.status;
      if (status === "completed") {
        setdisabled(true);
      }
      const newLinkId = sendMessageResponse.currentLinkId;

      const payloadContentString = sendMessageResponse.communications.find(
        (comm: any) => comm.sender.reference.includes("Device")
      );

      const contentString = payloadContentString.payload.find(
        (payloadItem: any) => payloadItem.contentString
      )?.contentString;
      const result = questionText?.some((item: any) =>
        item.text.includes(contentString)
      );

      setCurrentLinkId(newLinkId);

      const questionnaireResponseId =
        sendMessageResponse.questionnaireResponse.id;
      setQtresponseID(questionnaireResponseId);

      const item = sendMessageResponse.questionnaireResponse.item.find(
        (i: any) => i.linkId === newLinkId
      );

      const text = item ? item.text : null;

      const newQuestion = {
        id: messages.length + 2, // Increment ID to avoid duplicate keys
        content: contentString,
        time: new Date().toLocaleTimeString(),
        sender: false,
        ai: result,
      };

      setMessages((prevMessages) => [...prevMessages, newQuestion]); // Append both messages
      setLoading(false);
    }
  };

  const handleEductionMessage = async () => {
    if (!qtrResponseIdForChat || !newMessage.trim()) return;
    setNewMessage("");
    setLoading(true);
    const newMsgArray = [
      {
        id: messages.length + 1,
        content: newMessage,
        time: new Date().toLocaleTimeString(),
        sender: true,
        ai: true,
      },
    ];
    setMessages((prevMessages) => [...prevMessages, ...newMsgArray]);
    const msgRes = await getEducationChat(
      medplum,
      qtrResponseIdForChat,
      newMessage.trim(),
      chatContext ?? 'education'
    );
    if (!msgRes) return;
    newMsgArray.push({
      id: messages.length + 2, // Increment ID to avoid duplicate keys
      content: msgRes?.comm?.payload[0]?.contentString,
      time: new Date().toLocaleTimeString(),
      sender: false,
      ai: false,
    });

    setMessages((prevMessages) => [...prevMessages, newMsgArray[1]]); // Append both messages
    setLoading(false);
  };

  const handleStartChat = async () => {
    setdisabled(false)
    setMessages([]);

    const intiateChat = await startChat(medplum, patientId, qtrId, linkedIds);

    const contentString =
      intiateChat?.communications?.[0]?.payload?.[0]?.contentString ?? "--";
    const dateAndTime = intiateChat?.communications?.[0]?.sent;
    const date = new Date(dateAndTime);
    const localTime = date?.toLocaleString();
    const timePart = localTime?.split(", ")[1] ?? "--";

    setMessages([
      {
        id: 0,
        content: qtrResponseIdForChat
          ? "Welcome to Qconnect Education AI. How may I help you?"
          : "Welcome to QConnect Chat Bot",
        time: new Date().toLocaleTimeString(),
        sender: false,
        ai: true,
      },
      {
        id: messages.length + 1,
        content: contentString,
        time: timePart,
        sender: false,
        ai: true,
      },
    ]);
    setloader(false);

    const currentLinkId = intiateChat?.currentLinkId;
    const questionnaireResponseId = intiateChat?.questionnaireResponse?.id;
    setCurrentLinkId(currentLinkId);
    setQtresponseID(questionnaireResponseId);
  };

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Group
        position="apart"
        spacing="xl"
        sx={{ backgroundColor: "#338ff01c", borderRadius: "8px" }}
      >
        <Group p={12}>
          <div>
            <Title order={4} weight={700}>
              {patientName}{" "}
            </Title>
            <Text size="sm" color="dimmed">
              Mobile: {mobile} DOB: {dob}
            </Text>
          </div>
        </Group>
        <Group>
          <Button
            variant="outline"
            leftIcon={<Image src={aiStartsSvg} />}
            mr={20}
          >
            QConnect {chatContext === "education" && "Patient Education"}
            {chatContext === "medical-assistant" && "Patient Companion"}
          </Button>
        </Group>
      </Group>
      <Box
        ref={messagesContainerRef}
        sx={{
          height: embed ? "43vh" : "43vh",
          width: "100%",
          padding: "20px",
          overflowY: "auto",

          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": {
            width: "1px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
        }}
      >
        {" "}
        {loader ? (
          <Center>
            <Loader mt={180} variant="dots" />
          </Center>
        ) : (
          <>
            {messages.map((message) => (
              <>
                <ChatMessage
                  key={message.id}
                  message={message}
                  sender={message.sender}
                  patientName={patientName}
                />
              </>
            ))}
            {loading && <Loader size={"sm"} variant="dots" />}
          </>
        )}
      </Box>
      <Group noWrap>
        <Box
          sx={{
            display: "flex" as "flex",
            alignItems: "center" as "center",
            // gap: "16px",
            width: "100%",
          }}
        >
          <Input
            type="text"
            placeholder="Type a message"
            value={newMessage}
            disabled={disabled}
            onChange={(e: any) => setNewMessage(e.target.value)}
            size="lg"
            onKeyDown={(e: any) => {
              if (e.key === "Enter" && newMessage.trim() !== "") {
                if (launchType === "qnr") handleSendMessage();
                else if (launchType === "education") handleEductionMessage();
              }
            }}
            sx={{ flex: 1, padding: "10px", borderRadius: "5px" }}
          />

          <Button
            size="lg"
            variant="outline"
            onClick={
              launchType === "qnr" ? handleSendMessage : handleEductionMessage
            }
            disabled={loading || disabled}
            sx={{
              padding: "10px 10px",
              width: "50px",
              borderRadius: "5px",
              cursor: "pointer" as "pointer",
            }}
            bg="#F1F9FF"
          >
            <img src={arrowIcon} alt="Send" />
          </Button>
        </Box>{" "}
      </Group>
    </Box>
  );
};

export default ChatUI;
